module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/func_pr-b523338097154ebcb73ffe8cf03cc375.png";